<template>
  <div>
    <b-input-group prepend="Agent"
                   :id="getId()"
                   class="">
      <b-form-select v-model="selected" :id="`form-${getId()}`" @input="allocateAgent($event)">
        <option :value="null">Aucun</option>
        <option v-for="(user, index) in agents" :value="user.id" :key="index">
          {{ user.username || 'NR' }}
        </option>
      </b-form-select>
    </b-input-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SelectAgent',
  props: {
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    ...mapGetters([
    ]),
    agents() {
      if (this.getUsers() === null || typeof this.getUsers() === 'undefined') {
        return [];
      }
      return this.getUsers();// .filter(c => c.roles.indexOf('ROLE_AGENT') !== -1);
    },
  },
  methods: {
    ...mapGetters([
      'getUsers',
    ]),
    getId() {
      return `select-agent-${this._uid}`;
    },
    allocateAgent(selected) {
      // Emit event with user id
      this.$emit('allocateAgent', selected);
    },
  },
  mounted() {
    if (typeof this.getUsers() === 'undefined' || this.getUsers() === null) {
      this.$store.dispatch('getUsers').then(() => {}, () => {});
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/form/select/SelectAgent.vue